var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4485_36398)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4485_36398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 11,
    width: 56,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7213 11H4V52.791H59.7213V11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4485_36398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79919 52.7903H16.6639V31.2616L4 21.7637V48.9912C4 51.0934 5.7033 52.7903 7.79919 52.7903Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0576 52.7903H55.9223C58.0248 52.7903 59.7216 51.087 59.7216 48.9912V21.7637L47.0576 31.2616",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0576 14.7982V31.2614L59.7216 21.7634V16.6979C59.7216 11.9995 54.3585 9.32109 50.6036 12.1388",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 31.2619V14.7988L31.8608 26.1964L47.0574 14.7988V31.2619L31.8608 42.6595",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16.6979V21.7634L16.6639 31.2614V14.7982L13.1181 12.1388C9.35686 9.32109 4 11.9995 4 16.6979Z",
    fill: "#C5221F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_36398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 41.791,
    fill: "white",
    transform: "translate(4 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.e2df09220a52721621ead414c4b6d7df.svg";
export { ForwardRef as ReactComponent };